import * as React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Role } from '../types/members-types';
import CustomTooltip from '../../common/components/CustomTooltip';

export interface IRolesAutocompleteProps {
  roles: Role[];
}

const RoleChips: React.FC<React.PropsWithChildren<IRolesAutocompleteProps>> = ({
  roles,
}) => {
  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      {roles.map(role => {
        return (
          <CustomTooltip title={role.description} key={role.name}>
            <Chip
              key={role.name}
              label={role.name}
              size='small'
              variant='outlined'
            />
          </CustomTooltip>
        );
      })}
    </Stack>
  );
};

export default RoleChips;
